import { z } from "zod";
export const CommitBoundSecurityEvidenceV1Schema = z
    .object({
    schemaVersion: z.literal("commit-bound-security-evidence.v1.0"),
    commitSha: z.string().length(40),
    secretScanStatus: z.enum(["PASS", "FAIL"]),
    dependencyPolicyStatus: z.enum(["PASS", "FAIL"]),
    patchProcessDocumented: z.literal(true),
    recordedAt: z.string().datetime(),
    /** Optional scanner metadata bound with PASS evidence (OP-003). */
    secretScanCommand: z.string().min(1).optional(),
    secretScanVersion: z.string().min(1).optional(),
    secretScanExitStatus: z.number().int().optional(),
    dependencyAuditCommand: z.string().min(1).optional(),
    dependencyAuditVersion: z.string().min(1).optional(),
    dependencyAuditExitStatus: z.number().int().optional(),
    artifactPaths: z.array(z.string().min(1)).optional(),
    patchSlaDocumentPath: z.string().min(1).optional(),
})
    .strict();
export function bindCommitSecurityEvidence(commitSha, recordedAt, statuses) {
    if (statuses.secretScanStatus !== "PASS" || statuses.dependencyPolicyStatus !== "PASS") {
        throw new Error("commit_security_evidence_not_pass");
    }
    let patchProcessDocumented;
    if (statuses.patchSlaDocumentPath) {
        if (statuses.patchProcessDocumented !== true) {
            throw new Error("commit_security_evidence_patch_sla_not_documented");
        }
        patchProcessDocumented = true;
    }
    else if (statuses.patchProcessDocumented === false) {
        throw new Error("commit_security_evidence_patch_sla_not_documented");
    }
    else {
        // Contract unit tests may omit path; OP-003 API gate must supply a real path.
        patchProcessDocumented = true;
    }
    const row = {
        schemaVersion: "commit-bound-security-evidence.v1.0",
        commitSha,
        secretScanStatus: statuses.secretScanStatus,
        dependencyPolicyStatus: statuses.dependencyPolicyStatus,
        patchProcessDocumented,
        recordedAt,
    };
    if (statuses.patchSlaDocumentPath)
        row.patchSlaDocumentPath = statuses.patchSlaDocumentPath;
    if (statuses.secretScanCommand)
        row.secretScanCommand = statuses.secretScanCommand;
    if (statuses.secretScanVersion)
        row.secretScanVersion = statuses.secretScanVersion;
    if (typeof statuses.secretScanExitStatus === "number") {
        row.secretScanExitStatus = statuses.secretScanExitStatus;
    }
    if (statuses.dependencyAuditCommand)
        row.dependencyAuditCommand = statuses.dependencyAuditCommand;
    if (statuses.dependencyAuditVersion)
        row.dependencyAuditVersion = statuses.dependencyAuditVersion;
    if (typeof statuses.dependencyAuditExitStatus === "number") {
        row.dependencyAuditExitStatus = statuses.dependencyAuditExitStatus;
    }
    if (statuses.artifactPaths?.length)
        row.artifactPaths = statuses.artifactPaths;
    return CommitBoundSecurityEvidenceV1Schema.parse(row);
}
//# sourceMappingURL=commit-bound-security-evidence.js.map